export enum TaskType {
    GENERIC = 'generic',
    INTEREST_PAYMENT_CALCULATION = 'interest-payment-calculation',
    INTEREST_PAYMENT_PAYOUT = 'interest-payment-payout',
    EXPORT_INTEREST_PAYMENT_SEPA_CSV = 'export-interest-payment-sepa-csv',
    EXPORT_INTEREST_PAYMENT_EXCEL = 'export-interest-payment-excel',
    NYALA_RETRIEVE_REGISTRY_EXTRACT = 'nyala-retrieve-registry-extract',
    NYALA_CREATE_REGISTRY_EXTRACT = 'nyala-create-registry-extract',
    PAYMENT_ACCEPTANCE = 'payment-acceptance',
    NYALA_TRANSFER_TOKEN = 'nyala-transfer-token',
    EXPORT_CSV = 'export-csv',
    UPLOAD_ASSET_INVESTMENT_REPORT = 'upload-asset-investment-report',
    UPLOAD_ASSET_SECONDARY_MARKET_IMPORT = 'upload-asset-secondary-market-import',
    EXCLUSIVE_ACCEPTANCE = 'exclusive-acceptance',
    EXPORT_SIGNED_DOCUMENTS = 'export-signed-documents',
    SYNC_NYALA_INVESTMENT = 'sync-nyala-investment',
    EXPORT_INVESTOR_KYC_FOLDER = 'export-investor-kyc-folder',
    ASSET_ORDERS_SET_PAID = 'asset-orders-set-paid',
    ASSET_ORDERS_SET_PENDING = 'asset-orders-set-pending',
    RELEASE_FUNDS = 'release-funds',
    SEND_OPT_INS = 'send-opt-ins',
    UPDATE_STAKEHOLDER_AMOUNT = 'update-stakeholder-amount',
    EXPORT_XLSX = 'export-xlsx',
}

export enum TaskStatus {
    REGISTERED = 'registered',
    STARTED = 'started',
    FINISHED = 'finished',
}

export enum TaskFinishedType {
    SUCCESS = 'success',
    WARNING = 'warning',
    HAS_ERRORS = 'has-errors',
    ERROR = 'error',
    ERROR_WHILE_GENERATING = 'error_while_generating',
    PENDING = 'pending',
}

export enum TaskTaskableType {
    INTEREST_PAYMENT = 'InterestPayment',
    ASSET = 'Asset',
}
